module.exports = __webpack_public_path__ + "img/pr-3.699aae4d.png";